//Grant Match V2 Sidebar//
import { Drawer, SwipeableDrawer, SxProps } from '@mui/material'
import React, { FC } from 'react'
import { SidebarContent } from './SidebarContent'

interface SidebarProps {
  showSidebar: boolean
  mobileView: boolean
  toggleSidebar: (open: boolean) => void
}

const DrawerSx: SxProps = {
  flexShrink: 0,
  width: '272px',
  '& .MuiDrawer-paper': {
    width: '272px',
    boxSizing: 'border-box',
  },
}

export const Sidebar: FC<SidebarProps> = ({ showSidebar, mobileView, toggleSidebar }) => {

  return (
    <>
      {
        mobileView ?
          <SwipeableDrawer
            anchor="left"
            sx={DrawerSx}
            open={showSidebar}
            onClose={() => toggleSidebar(false)}
            onOpen={() => toggleSidebar(true)}
          >
            <SidebarContent toggleSidebar={toggleSidebar} />
          </SwipeableDrawer>
          :
          <Drawer
            open={true}
            anchor="left"
            sx={DrawerSx}
            variant="persistent"
          >
            <SidebarContent toggleSidebar={toggleSidebar} />
          </Drawer>
      }
    </>
  )
}
